import type { TextAreaChangeEvent } from "@progress/kendo-react-inputs";
import { useEffect, useState } from "react";
import type { UseFormSetValue } from "react-hook-form";
import GxBlackButtonSmall from "../../components/common/actions/buttons/GxBlackButtonSmall";
import GxPrimarySmallButton from "../../components/common/actions/buttons/GxPrimarySmallButton";
import { useT } from "@/app/hooks/useT";
import TextAreaInput from "@/app/components/common/actions/inputs-b/TextAreaInput";

interface RemarksModalProps {
  errors: any;
  setValue: UseFormSetValue<any>;
  isOpen: boolean;
  onClose: () => void;
  isReject: boolean;
  value: string;
  onChange: (value: string) => void;
  submit: () => void;
}
export const RemarksModal = ({
  errors,
  setValue,
  isOpen,
  onClose,
  isReject = false,
  value,
  onChange,
  submit,
}: RemarksModalProps) => {
  const [showModal, setShowModal] = useState(false);
  const t = useT();

  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
      document.body.style.overflow = "hidden";
    } else {
      const timeout = setTimeout(() => setShowModal(false), 300);
      document.body.style.overflow = "";
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  const sanitizeText = (text: string): string => {
    return text.replaceAll(/\s+/g, " ");
  };

  const handleOnChange = (value: string) => {
    const sanitizedValue = sanitizeText(value);
    onChange(sanitizedValue);

    if (isReject === true) {
      setValue("reason", sanitizedValue);
    } else {
      setValue("note", sanitizedValue);
    }
  };
  if (!isOpen && !showModal) return null;

  return (
    <div className="gx-custom-remark-modal-background">
      <div className="gx-custom-remark-modal-conatiner">
        <div className={`gx-custom-remark-modal ${isOpen ? "show" : "hide"}`}>
          <header className="gx-custom-remark-modal-header">
            <p className="gx-font-regular">
              {isReject ? t("reject") : t("repair")}
            </p>
            <span className="gx-font-bold">
              {" "}
              {isReject ? t("reason") : t("note")}
            </span>
          </header>
          <main className="gx-custom-remark-modal-main">
            <TextAreaInput
              value={value}
              onChange={handleOnChange}
              label={isReject ? t("reject_reason") : t("add_note")}
              rows={5}
              showLenth={false}
              required={true}
              validationMessage={
                errors?.note?.message || errors?.reason?.message
              }
            />
          </main>
          <footer className=" gx-custom-remark-modal-footer">
            <div className="space-x-4">
              <GxBlackButtonSmall onClick={onClose}>
                {t("cancel")}
              </GxBlackButtonSmall>
              <GxPrimarySmallButton
                handleSubmit={submit}
                label={isReject ? t("submit") : t("send")}
              />
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
